import React, { useState } from "react";
import searchIcon from "..//assets/res/search_black.svg";

function SearchBar({ querySearched }) {
  const [query, setQuery] = useState("");

  return (
    <div className="mt-[16px] mx-[24px] flex flex-row items-center rounded-2xl border border-gray-200 bg-white shadow-xl focus-within:ring-2 focus-within:ring-primaryLight">
      <div className="ml-4 h-6 w-6">
        <img src={searchIcon} className="h-6 w-6" alt="" />
      </div>
      <input
        type="text"
        placeholder="Search game/app/mod"
        className="w-full bg-transparent p-3.5 medium text-base placeholder:text-gray-400 focus:outline-none"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          querySearched(e.target.value);
        }}
      />
    </div>
  );
}

export default SearchBar;
